// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAnalytics from 'vue-analytics'
import Jargon from './components/Jargon'
import Word from './components/Word'
import WordContainer from './components/WordContainer'


let VueTouch = require("vue-touch");
VueTouch.config.swipe = {
  direction: "all"
};
VueTouch.config.pan = {
  threshold: 0
};
Vue.use(VueTouch, {name: "v-touch"});

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
    id: 'UA-106990899-4',
    router
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App, Jargon, Word, WordContainer}
});



// WEBPACK FOOTER //
// ./src/main.js